import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Card, CardBody, CardHeader, Container } from "reactstrap";

import Header from "../../../components/Headers/Header";
import Filter from "../Components/Filter/Filter";
import { ISelectedFilters } from "../../../types";
import CustomTable from "../../../components/Tables/CustomTable";
import HeaderWithDownload from "../../../components/HeaderWithDownload";

export default function StudentPerformanceImprovement() {
  const session = useSelector((state: any) => state.user.session);

  const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>();
  const [selectedFilterForReport, setSelectedFilterForReport] =
    useState<ISelectedFilters>();
  const daysRange = useMemo(
    () =>
      moment(selectedFilters?.date?.end_date).diff(
        selectedFilters?.date?.start_date,
        "days"
      ),
    [selectedFilters]
  );

  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <HeaderWithDownload
              title={`${
                daysRange <= 7 ? "Weekly" : "Monthly"
              } Student Performance Improvement`}
              reportType="performanceImprovement"
              selectedFilters={selectedFilterForReport}
            />

            <div className="pt-2">
              <Filter
                hasDistrictFilter
                hasBlockFilter
                hasSchoolFilter
                hasGradeFilter
                hasWeekMonthToggle
                onSearch={(selectedFilters) => {
                  setSelectedFilters(selectedFilters);
                }}
                onClear={() => {
                  setSelectedFilters(undefined);
                }}
                onFilterChange={(value) => setSelectedFilterForReport(value)}
              />
            </div>
          </CardHeader>

          <CardBody>
            <CustomTable
              url={`custom/stats_admin/student/performance/improvement?grade_id=${
                selectedFilters?.gradeId || -1
              }&student_id=-1&grade_section_id=-1&district=${
                selectedFilters?.districtId || -1
              }&block=${selectedFilters?.blockId || -1}&school=${
                selectedFilters?.schoolId || -1
              }&by_month_or_week=${
                daysRange || 7
              }&limit=${10}&offset=0&session=${session?.id}`}
              column={[
                { key: "srn_no", label: "SRN No." },
                { key: "first_name", label: "First name" },
                { key: "last_name", label: "Last name" },
                { key: "grade", label: "Grade" },
                { key: "section", label: "Section" },
                { key: "school", label: "School" },
                { key: "block", label: "Block" },
                { key: "district", label: "District" },
              ]}
              tableTitle={""}
              searchBox={false}
              itemsLimit={10}
              customFunction={() => {}}
              customColumns={[
                {
                  heading: "Current Points",
                  renderer: (each: any) => (
                    <span>{`${each?.curr_total_points}` || 0}</span>
                  ),
                },
                {
                  heading: "Previous Points",
                  renderer: (each: any) => (
                    <span>{`${each?.prev_total_points}` || 0}</span>
                  ),
                },
                {
                  heading: "Current Performance (%)",
                  renderer: (each: any) => (
                    <span>{`${each?.curr_performance}` || 0}</span>
                  ),
                },
                {
                  heading: "Previous Performance (%)",
                  renderer: (each: any) => (
                    <span>{`${each?.prev_performance}` || 0}</span>
                  ),
                },
                {
                  heading: "Current Attempted Right/Wrong",
                  renderer: (each: any) => (
                    <span>
                      {`${each?.curr_attempted_right}/${each?.curr_attempted_wrong}` ||
                        0}
                    </span>
                  ),
                },
                {
                  heading: " Previous Attempted Right/Wrong",
                  renderer: (each: any) => (
                    <span>
                      {`${each?.prev_attempted_right}/${each?.prev_attempted_wrong}` ||
                        0}
                    </span>
                  ),
                },
                {
                  heading: "Current Questions Attempted",
                  renderer: (each: any) => (
                    <span>{`${each?.curr_total_no_of_questions}` || 0}</span>
                  ),
                },
                {
                  heading: " Previous Questions Attempted",
                  renderer: (each: any) => (
                    <span>{`${each?.prev_total_no_of_questions}` || 0}</span>
                  ),
                },
              ]}
            />
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
